import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";

import { submitFormData, resetForm } from "../../actions/contentActions";
import { Link, useNavigate } from 'react-router-dom';

import {
  Modal,
  Grid2,
  Box,
  Paper,
  Typography,
  Button,
  InputLabel,
  FormControl,
  Alert,
  Snackbar
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import OutlinedInput from "../../themes/overrides/OutlinedInput";
import ModalBox from "../../themes/overrides/ModalBox";
import LoadingOverlay from "../../components/LoadingOverlay";
import { useParams } from 'react-router-dom';

const ContentPopup = ({ isOpen, onClose, onSuccess }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const { workspaceId } = useParams();
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [submitError, setSubmitError] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      slug: "",
      description: "",
    },
  });

  const transformSlug = (name) => {
    const words = name.split(/[\s-]+/);
    const camelCaseSlug = words
      .map((word, index) =>
        index === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join("");
    setValue("slug", camelCaseSlug);
  };

  const onSubmit = async (data) => {
    if (!data.name || !data.slug) {

    }
    const formData = {
      workspaceId,
      ...data
    }

    if (formData.name.trim() == "") {
      setSubmitError("Content model name cannot be empty or just spaces");
      return; // Return to prevent submission
    }


    setLoading(true)
    try {
      const res = await dispatch(
        submitFormData(formData)
      )
      if (res?.status === "success") {
        const contentTypeId = res?.contentTypeId;
        navigate(`/${workspaceId}/content-type/${contentTypeId}`);
        setSuccessMessage("Content type created successfully");
        setOpenSnackbar(true);
        setSeverity("success");
        reset();
        onClose();
      } else {
        setSuccessMessage(res.message);
        setOpenSnackbar(true);
        setSeverity("error");
      }
    }
    catch (error) {
      setSuccessMessage(error);
      setOpenSnackbar(true);
      setSeverity("error");
    } finally {
      setLoading(false)
    }
  };
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    setErrorMessage("");
  };

  const handleClose = () => {
    reset();
    onClose();
  }
  return (
    <>
      <Modal open={isOpen} onClose={handleClose}>
        <ModalBox
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          sx={{
            width: { xs: '95%', sm: '600px', md: '700px' },
            maxHeight: { xs: '95vh', sm: '90vh' },
          }}
        >
          <Typography variant="h5" sx={{ marginBottom: 2 }}>
            Create Content Model
          </Typography>
          {
            success && (
              <Alert severity="success">Content type created successfully!</Alert>
            )
          }
          <FormControl variant="standard" fullWidth>
            <InputLabel shrink htmlFor="name">
              Name
            </InputLabel>
            <OutlinedInput
              {...register("name", { required: "Name is required" })}
              // fullWidth
              margin="normal"
              error={!!errors.name}
              helperText={errors.name?.message}
              onChange={(e) => transformSlug(e.target.value)}
            />
          </FormControl>

          <FormControl variant="standard" fullWidth>
            <InputLabel shrink htmlFor="slug">
              Slug
            </InputLabel>
            <OutlinedInput
              {...register("slug", {
                required: "Slug is required",
                pattern: {
                  value: /^[a-zA-Z0-9]+$/,
                  message: "Slug must be a single camel-case word",
                },
              })}
              // fullWidth
              margin="normal"
              error={!!errors.slug}
              helperText={errors.slug?.message}
            />
          </FormControl>

          <FormControl variant="standard" fullWidth>
            <InputLabel shrink htmlFor="description">
              Description
            </InputLabel>
            <OutlinedInput
              {...register("description")}
              // fullWidth
              margin="normal"
              error={!!errors.description}
              helperText={errors.description?.message}
              // multiline
              maxRows={4}
            />
          </FormControl>
          {submitError && (
            <div className="my-2 text-sm text-red-600">
              {submitError}
            </div>
          )}
          <Button type="submit" fullWidth variant="contained" sx={{ background: 'linear-gradient(90deg, rgba(62,142,255,1) 0%, rgba(36,93,173,1) 35%)' }}>
            Publish
          </Button>
        </ModalBox>
      </Modal>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {severity === "success" ? successMessage : errorMessage}
        </Alert>
      </Snackbar>
      {loading && <LoadingOverlay />}
    </>
  );
};

export default ContentPopup;
